import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { Close } from '@element-plus/icons-vue';
import { sensorsExposure } from '@/utils/sensors';
export default {
  props: {
    content: {
      type: String,
      default: '',
      required: true
    }
  },
  emits: ['update:content'],
  components: {
    Close
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const handleConfirm = () => {
      emit('update:content', false);
    };
    watch(() => props.content, content => {
      if (content) {
        sensorsExposure({
          page_section: 'fundpool_unavailable'
        });
      }
    });
    return {
      t,
      handleConfirm
    };
  }
};